module.exports = __webpack_public_path__ + "assets/illu-catalog.0cdc582b820670c14cf300f659bf2c48.svg";